/*
 * Copyright (c) 2017, Globo.com <https://github.com/globocom/megadraft-table-plugin>
 *
 * License: MIT
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon';

import TableView from './TableView';
import { TableConfig, validate } from './TableConfig';
import { TableManagerActions } from './TableManagerActions';
import { TableManagerMetadata } from './TableManagerMetadata';
import { correctSelectedCellIndex } from './TableManagerHelper';

export default class TableManagerModal extends Component {
  static propTypes = {
    onCloseRequest: PropTypes.func,
    onSaveRequest: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this._onSaveRequest = this._onSaveRequest.bind(this);
    this.onFormItemChange = this.onFormItemChange.bind(this);
    this.onChangeRows = this.onChangeRows.bind(this);
    this.onChangeSelection = this.onChangeSelection.bind(this);
    this.state = {
      data: new TableConfig(this.props.data),
      selectedCell: [0, 0],
      errors: {},
    };
    this.selectedCell = [0, 0];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.data) {
      const data = new TableConfig({ ...nextProps.data });
      const errors = {};
      const selectedCell = [0, 0];
      this.setState({ data, errors, selectedCell });
    }
  }

  _onSaveRequest() {
    if (true) {
      this.props.onSaveRequest(this.state.data);
    }
  }

  isValid() {
    const newErrors = validate(this.state.data);
    this.setState({ errors: newErrors });
    return JSON.stringify(newErrors) === JSON.stringify({});
  }

  _changeDataValue(prop, newValue) {
    const newData = { [prop]: newValue };
    const data = Object.assign({}, this.state.data, newData);
    this.setState({ data });
  }

  onFormItemChange(e) {
    const { name, value } = e.target;
    this._changeDataValue(name, value);
  }

  onChangeRows(rows) {
    this._changeDataValue('rows', rows);
  }

  onChangeSelection(selectedCell) {
    selectedCell = correctSelectedCellIndex(selectedCell, this.state.data.rows);
    this.setState({ selectedCell: selectedCell });
  }

  onEditTableCell(rowIndex, columnIndex, value) {
    this.state.data.rows[rowIndex][columnIndex] = value;
    this._changeDataValue('rows', this.state.data.rows);
    this.onChangeSelection([columnIndex, rowIndex]);
  }

  render() {
    const { data, errors } = this.state;
    if (!this.props.isOpen) {
      return null;
    }
    return (
      <div className="table-manager-modal">
        <div style={{ width: '100%', maxWidth: '800px' }}>
          <div
            style={{ position: 'relative' }}
            className="table-manager-modal__form"
          >
            <Icon
              style={{ position: 'absolute', right: '10px' }}
              icon="icon-close"
              buttonStyle
              onClick={this.props.onCloseRequest}
              fontSize={'15px'}
            />

            <TableManagerMetadata
              onChange={this.onFormItemChange}
              data={data}
              errors={errors}
            />

            <TableManagerActions
              onChangeRows={this.onChangeRows}
              selectedCell={this.state.selectedCell}
              rows={data.rows}
            />
          </div>

          <div className="table-manager-modal__editable-table">
            <div className="table-manager-modal__table-wrapper">
              <TableView
                rows={this.state.data.rows}
                onEditCell={this.onEditTableCell.bind(this)}
                onChangeRows={this.onChangeRows}
                headerStyle={data.headerStyle}
                editable={true}
                selectedCell={this.selectedCell}
                onChangeSelection={this.onChangeSelection}
              />
            </div>
          </div>
          <button className="save" onClick={this._onSaveRequest}>
            Save
          </button>
        </div>
      </div>
    );
  }
}
